import { render, staticRenderFns } from "./dialogAddApprover.vue?vue&type=template&id=1d98e89e&scoped=true"
import script from "./dialogAddApprover.vue?vue&type=script&lang=js"
export * from "./dialogAddApprover.vue?vue&type=script&lang=js"
import style0 from "./dialogAddApprover.vue?vue&type=style&index=0&id=1d98e89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d98e89e",
  null
  
)

export default component.exports